import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ModalController, NavParams, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-popover-iframe',
  templateUrl: './popover-iframe.component.html',
  styleUrls: ['./popover-iframe.component.scss'],
})
export class PopoverIframeComponent {

  public title:string = "";
  public url:string = "";
  public iFrameURL:any;
  
  constructor(
    public viewCtrl: ModalController, 
    private sanitizer: DomSanitizer,
    public navParams: NavParams,
    public popOverCtrl: PopoverController
    )
    {
      this.title = this.navParams.data.data.title ? this.navParams.data.data.title : "";
      let url = this.navParams.data.data.url;
      if(url) {
        this.iFrameURL = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      } else {
        this.iFrameURL = null;
      }
    }

closePopover() {
  this.popOverCtrl.dismiss( false);
}
}